/**
 * Route for `regional-dns`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RegionalDnsPage } from "../features/regional-dns/RegionalDnsPage";

export const regionalDnsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/regional-dns",
	component: RegionalDnsPage,
});

export default regionalDnsRoute;
